import React from "react";
import {Button, makeStyles, useTheme} from '@material-ui/core';
import t from "../../../languages/pl";
import {bindActionCreators} from "redux";
import ActionCreator from "../../../store/actions";
import {compose} from "recompose";
import {connect} from "react-redux";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    image: {
        height: 25,
        width: 36,
    },
    container: {
        display: "flex"
    },
    text: {
        marginLeft: theme.spacing(1)
    },
    icon: {
        minWidth: 20,
        minHeight: 20,
        margin: theme.spacing(1)
    },
    buttonColor: {
        background: "#A3A0FB",
        color: "#000",
        "&:hover": {
            background: "#7270AF",
        },
        marginRight: 12
    }
}));

const CenterButton = ({mapManuallyMoved, manuallyMovedOrZoomed, fitInBounds}) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const handleButtonClick = () => {
        manuallyMovedOrZoomed(false);
        fitInBounds();
    };


    return (
        <React.Fragment>
            {mapManuallyMoved ? <Button
                variant="contained"
                size="small"
                color="secondary"
                classes={{containedSecondary: classes.buttonColor}}
                onClick={handleButtonClick}
            >
                {t.center}
            </Button> : <></>}
        </React.Fragment>
    );
};

CenterButton.propTypes = {
    mapManuallyMoved: PropTypes.bool,
    manuallyMovedOrZoomed: PropTypes.func,
    fitInBounds: PropTypes.func,
};

const mapStateToProps = state => {
    return {
        mapManuallyMoved: state.mapReducer.mapManuallyMoved,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
)(CenterButton);